import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "href", "className", "children"],
  _excluded2 = ["htmlProps"],
  _excluded3 = ["htmlProps"],
  _excluded4 = ["htmlProps"],
  _excluded5 = ["htmlProps"];
import { forwardRef } from 'react';
import cn from 'classnames';
import parseClassnames from "../helpers/parseClassnames";
import { BUTTON } from "./classnames";
import { jsx as _jsx } from "react/jsx-runtime";
var BaseButton = function BaseButton(_ref, ref) {
  var as = _ref.as,
    href = _ref.href,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    baseButtonProps = _objectWithoutProperties(_ref, _excluded);
  var wrapperClassName = parseClassnames(className, cn(BUTTON, {
    'pointer-events-none': baseButtonProps.disabled
  }));
  if (as === 'a' || href) {
    var _ref2 = baseButtonProps,
      _htmlProps = _ref2.htmlProps,
      aProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      href: href,
      className: wrapperClassName
    }, _htmlProps), aProps), {}, {
      children: children
    }));
  }
  if (as === 'label') {
    var _ref3 = baseButtonProps,
      _htmlProps2 = _ref3.htmlProps,
      labelProps = _objectWithoutProperties(_ref3, _excluded3);
    return /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps2), labelProps), {}, {
      children: children
    }));
  }
  if (as === 'span') {
    var _ref4 = baseButtonProps,
      _htmlProps3 = _ref4.htmlProps,
      spanProps = _objectWithoutProperties(_ref4, _excluded4);
    return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps3), spanProps), {}, {
      children: children
    }));
  }
  var _ref5 = baseButtonProps,
    htmlProps = _ref5.htmlProps,
    buttonProps = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    type: "button",
    className: wrapperClassName
  }, htmlProps), buttonProps), {}, {
    children: children
  }));
};
export default /*#__PURE__*/forwardRef(BaseButton);